//Visaulizador de PDF
import React, { lazy, Suspense } from 'react'

// pdf.js pesa bastante: solo se descarga en los navegadores que lo necesitan
const PdfCanvasViewer = lazy(() => import('./PdfCanvasViewer'))

// Chrome Android (y otros navegadores móviles) no traen visor de PDF integrado: el iframe
// solo pinta un placeholder con el nombre del blob y un botón "Abrir" que no funciona.
// navigator.pdfViewerEnabled es false en esos casos; si no existe, mantenemos el iframe.
const canShowPdfInline = () => navigator.pdfViewerEnabled !== false

const PdfViewer = ({ docSelected }) => {
    return (
        <>
            {
                docSelected.length > 0 ?
                    canShowPdfInline() ?
                        <iframe
                            title="Documento PDF"
                            className="product-detail__pdf-section-view"
                            src={docSelected}
                        />
                    : <Suspense fallback={<span style={{ color: "white" }} >Cargando visor...</span>}>
                        <PdfCanvasViewer url={docSelected} />
                    </Suspense>
                : <span style={{ color: "white" }} >Selecciona un documento para visualizar</span>
            }
        </>
       )
}
export default PdfViewer
